import type { JSX } from 'react';

import rem from 'styles/functions/rem';

export type Token =
  | 'headerExtraLarge'
  | 'headerLarge'
  | 'headerMedium'
  | 'headerRegular'
  | 'headerSmall'
  | 'body'
  | 'bodySemibold'
  | 'bodySmall'
  | 'bodySmallSemibold'
  | 'monospace';

export const TOKEN_ELEMENT_MAP: Record<Token, keyof JSX.IntrinsicElements> = {
  headerExtraLarge: 'h1',
  headerLarge: 'h2',
  headerMedium: 'h3',
  headerRegular: 'h4',
  headerSmall: 'h5',
  body: 'p',
  bodySemibold: 'p',
  bodySmall: 'span',
  bodySmallSemibold: 'span',
  monospace: 'code',
};

export interface Text {
  font: {
    /** '"Proxima Nova", sans-serif;' */
    heading: string;
    /** '"Proxima Nova", sans-serif;' */
    body: string;
    /** '"Roboto Mono", monospace' */
    monospace: string;
  };
  size: {
    header: {
      /** 40px */
      extraLarge: string;
      /** 24px */
      large: string;
      /** 18px */
      medium: string;
      /** 16px */
      regular: string;
      /** 12px */
      small: string;
    };
    body: {
      /** 14px */
      regular: string;
      /** 12px */
      small: string;
    };
  };
  weight: {
    /** 200 */
    light: number;
    /** 300 */
    normal: number;
    /** 400 */
    regular: number;
    /** 500 */
    medium: number;
    /** 600 */
    semibold: number;
    /** 700 */
    bold: number;
  };
  lineHeight: {
    /** 1 */
    exact: number;
    /** 1.2 */
    tight: number;
    /** 1.5 */
    normal: number;
    /** 2 */
    loose: number;
  };
  letterSpacing: {
    /** -2% */
    tight: string;
    /** 0px */
    normal: string;
  };
}

const text: Text = {
  font: {
    heading: '"Proxima Nova", sans-serif;',
    body: '"Proxima Nova", sans-serif;',
    monospace: '"Roboto Mono", monospace',
  },
  size: {
    header: {
      extraLarge: rem(40),
      large: rem(24),
      medium: rem(18),
      regular: rem(16),
      small: rem(12),
    },
    body: {
      regular: rem(14),
      small: rem(12),
    },
  },
  weight: {
    light: 200,
    normal: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  lineHeight: {
    exact: 1,
    tight: 1.2,
    normal: 1.5,
    loose: 2,
  },
  letterSpacing: {
    tight: '-0.02em',
    normal: rem(0),
  },
};

export default text;
